import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-hoebestellen',
  templateUrl: '../../../assets/html/hoebestellen.html',
  styleUrls: ['./hoebestellen.component.css']
})
export class HoebestellenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
